// Note on ARM: WHEN MIGRATING OFF OF ANGULAR, THIS FILE CAN BE BROKEN DOWN FURTEHR TO MOVE RELEVANT INTO CONTENT TYPE SPECIFIC MODULE. E.G. flow related code would go in revisionHistoryFlow module
import { RevisionHistoryDialogCtrl } from '../../revisionHistory/controllers/RevisionHistoryDialogCtrl';
import { IActionContext } from '../../ts/helpers/ActionContext';
import { Set } from '../../ts/models/Set';
import { Module } from '../../ts/Module';
import { IContentRevision } from '../serverApi/types/IContentRevision';
import { IWorkbookRevision } from '../../revisionHistoryWorkbook/serverApi/types/IWorkbookRevision';
import { IDatasourceRevision } from '../../revisionHistoryDatasource/serverApi/types/IDatasourceRevision';
import { FlowRevision } from '../../revisionHistoryFlow/serverApi/types/FlowRevision';
import { IActionButton } from '../../ts/services/ActionPanelService';
import { DeleteRevisionAction } from './DeleteRevisionAction';
import { DownloadActions } from '../../ts/services/download/DownloadActions';
import { PreviewWorkbookRevisionAction } from '../../revisionHistoryWorkbook/services/PreviewWorkbookRevisionAction';

export class RevisionActions {

  public static $inject = ['PreviewWorkbookRevisionAction',
                           'DeleteRevisionAction'];

  private datasourceRevisionsActionDefinition: IActionButton<IDatasourceRevision, {}>[];
  private flowRevisionsActionDefinition: IActionButton<FlowRevision, {}>[];
  private workbookRevisionsActionDefinition: IActionButton<IWorkbookRevision, {}>[];

  constructor(private PreviewWorkbookRevisionAction: PreviewWorkbookRevisionAction,
              private DeleteRevisionAction: DeleteRevisionAction) {

    this.datasourceRevisionsActionDefinition = [
      this.deleteDataSourceRevisionAction(),
      this.downloadContentRevisionAction()
    ];

    this.workbookRevisionsActionDefinition = [
      this.previewWorkbookRevisionAction(),
      this.deleteWorkbookRevisionAction(),
      this.downloadContentRevisionAction()
    ];

    this.flowRevisionsActionDefinition = [
      this.deleteFlowRevisionAction(),
      this.downloadContentRevisionAction()
    ];

  }

  // public api

  public getWorkbookRevisionActionButtons(): IActionButton<IWorkbookRevision, {}>[] {
    return this.workbookRevisionsActionDefinition;
  }

  public getDatasourceRevisionActionButtons(): IActionButton<IDatasourceRevision, {}>[] {
    return this.datasourceRevisionsActionDefinition;
  }

  public getFlowRevisionActionButtons(): IActionButton<FlowRevision, {}>[] {
    return this.flowRevisionsActionDefinition;
  }

  // action button factories

  private previewWorkbookRevisionAction(): IActionButton<IWorkbookRevision, {}> {
    return {
      name: 'preview',
      translate: 'preview_action',
      isAvailable: (items: Set<IWorkbookRevision>) => true,
      execute: (items: Set<IWorkbookRevision>) => {
        this.PreviewWorkbookRevisionAction.openPreview(items.first());
      }
    };
  }

  private deleteDataSourceRevisionAction(): IActionButton<IDatasourceRevision, {}> {
    return {
      name: 'delete',
      translate: 'delete_action',
      isAvailable: (items: Set<IDatasourceRevision>) => items.size() === 1,
      execute: (items: Set<IDatasourceRevision>, context: IActionContext) => {
        const scope = <RevisionHistoryDialogCtrl.Scope>context.scope;
        this.DeleteRevisionAction.showDeleteDataSourceRevisionDialog(items.first(), context).then(() => scope.refreshContent());
      }
    };
  }

  private deleteWorkbookRevisionAction(): IActionButton<IWorkbookRevision, {}> {
    return {
      name: 'delete',
      translate: 'delete_action',
      isAvailable: (items: Set<IWorkbookRevision>) => items.size() === 1,
      execute: (items: Set<IWorkbookRevision>, context: IActionContext) => {
        const scope = <RevisionHistoryDialogCtrl.Scope>context.scope;
        this.DeleteRevisionAction.showDeleteWorkbookRevisionDialog(items.first(), context).then(() => scope.refreshContent());
      }
    };
  }

  private downloadContentRevisionAction(): IActionButton<IContentRevision, {}> {
    return {
      name: 'download',
      translate: 'download_action',
      isAvailable: (items: Set<IContentRevision>) => true,
      execute: (items: Set<IContentRevision>) => {
        DownloadActions.downloadContentRevision(items.first());
      }
    };
  }

  private deleteFlowRevisionAction(): IActionButton<FlowRevision, {}> {
    return {
      name: 'delete',
      translate: 'delete_action',
      isAvailable: (items: Set<FlowRevision>) => items.size() === 1,
      execute: (items: Set<FlowRevision>, context: IActionContext) => {
        const scope = <RevisionHistoryDialogCtrl.Scope>context.scope;
        this.DeleteRevisionAction.showDeleteFlowRevisionDialog(items.first(), context).then(() => scope.refreshContent());
      }
    };
  }
}

Module.instance().service('RevisionActions', RevisionActions);
